var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserbased(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 8.25C9.5 9.04565 9.81607 9.80871 10.3787 10.3713C10.9413 10.9339 11.7044 11.25 12.5 11.25C13.2956 11.25 14.0587 10.9339 14.6213 10.3713C15.1839 9.80871 15.5 9.04565 15.5 8.25C15.5 7.45435 15.1839 6.69129 14.6213 6.12868C14.0587 5.56607 13.2956 5.25 12.5 5.25C11.7044 5.25 10.9413 5.56607 10.3787 6.12868C9.81607 6.69129 9.5 7.45435 9.5 8.25Z",
    stroke: "#172B4D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 18.75V17.25C8 16.4544 8.31607 15.6913 8.87868 15.1287C9.44129 14.5661 10.2044 14.25 11 14.25H14C14.7956 14.25 15.5587 14.5661 16.1213 15.1287C16.6839 15.6913 17 16.4544 17 17.25V18.75",
    stroke: "#00C170",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserbased);
export default __webpack_public_path__ + "static/media/userbased.c0238a2e509ee37507f89011ae3f72b4.svg";
export { ForwardRef as ReactComponent };